import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component } from 'react';
import { apiFetch, API } from "../../services/api";

// La suppression se fait par ?id= (pas de body), conformément au back_api.
function deleteWidget(widget) {
    return apiFetch(API.back + '/shoe-rotation-widget?id=' + encodeURIComponent(widget.id), {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    });
}

export default class DeleteShoeRotationWidgetModal extends Component {
    state = { loading: false, error: null };

    handleDelete = () => {
        this.setState({ loading: true, error: null });
        deleteWidget(this.props.selectedItem)
            .then(async () => {
                if (this.props.refresh) {
                    await this.props.refresh();
                }
                this.props.closeModal();
            })
            .catch(err => {
                console.log(err);
                this.setState({ loading: false, error: "Erreur lors de la suppression" });
            });
    };

    render() {
        return (
            <Modal
                show={this.props.isOpen}
                onHide={this.props.closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Suppression du widget {this.props.selectedItem.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Voulez-vous vraiment supprimer le widget « {this.props.selectedItem.title} » ?</p>
                    <p className="text-muted">Les iframes déjà collées dans les articles cesseront de s'afficher.</p>
                    {this.state.error ? <p style={{ color: "#c0392b" }}>{this.state.error}</p> : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" type="cancel" onClick={this.props.closeModal}>
                        Annuler
                    </Button>
                    <Button variant="primary" type="submit" onClick={this.handleDelete} disabled={this.state.loading}>
                        {this.state.loading ? "Suppression…" : "Valider"}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}
